




















import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex";
import { ElInput } from "element-ui/types/input";

@Component({
    ...mapGetters(["accountBook"])
})
export default class addAssist extends Vue {
    @Prop({type:String})
    type:any;

    @Prop({type:[String, Number]})
    no:any;

    addInfo: any = {
        code: "",
        name: "",
        unit: ""
    };
    disConfirm: boolean = true;

    mounted() {
        this.$nextTick(() => {
            this.addInfo.code = this.no            
        })
    }

    @Watch("addInfo",{deep: true})
    addInfoChange(val:any){
        if (val.code != "" && val.name != "") this.disConfirm = false
        else this.disConfirm = true
        let no = Number(val.code);
        if (no == 0) {
            val.code = ""
        } else {
            if (no < 10 && no != 0) val.code = "000" + no
            else if (no < 100) val.code = "00" + no
            else if (no < 1000) val.code = "0" + no
            else val.code = no
        }
    }

    initData() {
        this.addInfo.code = this.no;
        this.addInfo.name = "";
    }
    // enter 快捷键
    toNextInput(i:any) {
        if (i === 0) {
            (<ElInput>this.$refs.nameInput).focus();
        } else {
            if (i === 1) {
                if (this.type === "存货") (<ElInput>this.$refs.unitInput).focus();
                else if (!this.disConfirm) this.confirmAdd();
            } else {
                if (!this.disConfirm) this.confirmAdd();
            }
        }
    }
    focusCode(e:any) {
        // e.target.value = this.no
        if (this.addInfo.code == "")
            this.addInfo.code = this.no
    }
    closeAdd() {
        this.$emit("close")
    }
    confirmAdd() {
        let assType = "";
        switch (this.type) {
            case "项目":
                assType = "dim/item";
                break
            case "客户":
                assType = "dim/customer";
                break
            case "供应商":
                assType = "dim/provider";
                break
            case "部门":
                assType = "dim/department";
                break
            case "员工":
                assType = "dim/employee"
                break
            default:
                assType = "dim/inventory"
        }
        Vue.axios.post(assType + "/add",{
            "accountBookId": this.$store.state.accountBook.id,
            "no": this.addInfo.code,
            "name": this.addInfo.name,
            measureUnit: this.addInfo.unit
        }).then(response => {                
            this.$emit("confirm", response)
        })
    }
}
